module.exports = __webpack_public_path__ + "img/d10.0afe1fe1.svg";